var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.333 40.625a5.208 5.208 0 015.209-5.208h28.125",
    stroke: "#C3C3C3",
    strokeWidth: 4.167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.542 4.167h28.125v41.666H13.542a5.208 5.208 0 01-5.209-5.208V9.375a5.208 5.208 0 015.209-5.208z",
    stroke: "#C3C3C3",
    strokeWidth: 4.167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgCourseIc;